export default __webpack_public_path__ + "static/media/ketto.4e6f9f44.svg";